import { BicycleCargoIcon } from './BicycleCargoIcon';

/**
 * author: Teodor Sandu
 * id 63EFAAFD-2EB5-4600-930D-33CEDDC182A5
 * name bicycle-cargo
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bicycle-cargo.svg
 * tags
 * - Transportation + Other 
 * - Sport 
 */
export const BikeCargoIcon = BicycleCargoIcon;
export default BikeCargoIcon